import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import { useState } from 'react'

type ParentExtractedDataEditProps = {
  onEnabled: () => void
}

const ParentExtractedDataEdit = ({ onEnabled }: ParentExtractedDataEditProps) => {
  const [open, setOpen] = useState(false)

  const confirm = () => {
    onEnabled()
    setOpen(false)
  }

  return (
    <>
      <Button variant="outlined" onClick={() => setOpen(true)}>
        Modifier les informations extraites
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Modifier les informations du parent employeur</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Les informations déverrouillées doivent correspondre exactement à celles figurant sur
            le bulletin de paie déposé à l’étape précédente. Une différence peut empêcher la
            validation du dossier IPERIA.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Annuler</Button>
          <Button variant="contained" onClick={confirm}>
            Modifier quand même
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ParentExtractedDataEdit
